import { Platform } from 'core/common/entities';
import { Languages } from 'core/localization/entities';
import { getCurrentLanguage } from 'core/localization/utils/getCurrentLanguage';
import { UtmSource } from 'core/user/entities';

export type SystemState = {
  isTestingEnv: boolean;
  language: Languages;
  isAppleMobile: boolean;
  isApplePaySupported: boolean;
  isMobileDevice: boolean;
  source: UtmSource;
  platform: Platform;
};

export const systemInitialState: SystemState = {
  isTestingEnv: false,
  language: getCurrentLanguage(),
  isApplePaySupported: false,
  isAppleMobile: false,
  isMobileDevice: false,
  source: UtmSource.NO_SOURCE,
  platform: Platform.UNKNOWN,
};
